import React, { useState } from 'react';
import { getAuth } from 'firebase/auth';
import { UpdateWorkflowCollaborators } from '../../Client/ManagementServiceClient';

// Roster + management for workflow collaborators. The owner can invite people
// by email, change their role (viewer/editor), and remove them. Everyone else
// sees a read-only roster.
function CollaboratorsPanel({ workflowId, myRole, collaborators, onChange }) {
    const isOwner = myRole === 'owner';
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('editor');
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    const mutate = async (request) => {
        setBusy(true);
        setErr('');
        try {
            const auth = getAuth();
            const idToken = await auth.currentUser.getIdToken();
            const { status, myJson } = await UpdateWorkflowCollaborators(idToken, workflowId, request);
            if (status === 200) {
                onChange?.(myJson);
            } else {
                setErr(myJson?.detail?.Message || myJson?.detail || 'Request failed');
            }
        } catch (e) {
            setErr(e.message || 'Error');
        } finally {
            setBusy(false);
        }
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        const trimmed = email.trim();
        if (!trimmed) return;
        await mutate({ action: 'add', email: trimmed, role });
        setEmail('');
    };

    const list = collaborators || [];

    return (
        <div className="collaborators-panel">
            <div className="collaborators-title">Collaborators</div>

            <ul className="collaborators-list">
                <li className="collaborator-item">
                    <span className="collaborator-name">{isOwner ? 'You' : 'Owner'}</span>
                    <span className="collaborator-role role-owner">owner</span>
                </li>
                {list.map((c) => (
                    <li key={c.user_id} className="collaborator-item">
                        <span className="collaborator-name">{c.username || c.user_id}</span>
                        {isOwner ? (
                            <span className="collaborator-controls">
                                <select
                                    value={c.role}
                                    disabled={busy}
                                    onChange={(e) => mutate({ action: 'update_role', user_id: c.user_id, role: e.target.value })}
                                >
                                    <option value="viewer">viewer</option>
                                    <option value="editor">editor</option>
                                </select>
                                <button
                                    type="button"
                                    className="collaborator-remove"
                                    disabled={busy}
                                    onClick={() => mutate({ action: 'remove', user_id: c.user_id })}
                                >
                                    Remove
                                </button>
                            </span>
                        ) : (
                            <span className={`collaborator-role role-${c.role}`}>{c.role}</span>
                        )}
                    </li>
                ))}
            </ul>

            {isOwner && (
                <form className="collaborator-add" onSubmit={handleAdd}>
                    <input
                        type="email"
                        placeholder="Invite by email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={busy}
                    />
                    <select value={role} onChange={(e) => setRole(e.target.value)} disabled={busy}>
                        <option value="editor">editor</option>
                        <option value="viewer">viewer</option>
                    </select>
                    <button type="submit" disabled={busy || !email.trim()}>Add</button>
                </form>
            )}

            {err && <div className="collaborator-error">{err}</div>}
        </div>
    );
}

export { CollaboratorsPanel };
